import Tickets from '../views/tickets/Index.vue';
import { checkauth } from '../Helper';

export default [
	{
		path: '/tickets',
		name: 'Tickets',
		component: Tickets,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				if (response) {
					next();
				} else {
					next('/login');
				}
			});
		},
	},
];
